<template>
  <div class="audio-time-ind">
    <time class="audio-time-ind__current">{{ currentTime }}</time>
    <time class="audio-time-ind__duration">{{ durationTime }}</time>
  </div>
</template>

<script setup>
  const props = defineProps({
    //Текущее время
    currentTime: { type: String },
    //Длительность аудио
    durationTime: { type: String }
  });
</script>

<style lang="scss" scoped>
  @import'./styles';
</style>